export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z\" clip-rule=\"evenodd\"/><path fill=\"#00809D\" fill-rule=\"evenodd\" d=\"M41.922 15.618a.998.998 0 00-.923-.618h-9a1 1 0 000 2h6.587l-8.773 8.773 1.414 1.414 8.772-8.773V25a1 1 0 102 0v-9c0-.13-.026-.26-.077-.382M26.75 28.836l-6.793-6.793a.999.999 0 00-1.414 0l-11.25 11.25a1 1 0 001.414 1.414L19.25 24.164l6.793 6.793a1 1 0 001.414 0l.73-.73-1.415-1.413-.022.022zM12 12.414l25.456 25.457 1.414-1.414L13.414 11 12 12.414z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};